module.exports = __webpack_public_path__ + "static/media/preview_purple.7532bad8.svg";